import { useAuthStore } from '@/stores/modules/auth'

export function usePermission() {
  const authStore = useAuthStore()

  function hasPermission(permission: string): boolean {
    if (authStore.roles.includes('admin')) return true
    return authStore.permissions.includes(permission)
  }

  function hasRole(role: string): boolean {
    return authStore.roles.includes(role)
  }

  return { hasPermission, hasRole }
}
